/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Artifact_Suggestions_ShowInputs */



/**
* | output |
* | --- |
* | "{count} AI Change(s)" |
*
* @param {Artifact_Suggestions_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_suggestions_show = /** @type {((inputs: Artifact_Suggestions_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Suggestions_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} KI-Änderung(en)`)
	return /** @type {LocalizedString} */ (`${i?.count} AI Change(s)`)
});